var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWrongProducts = function SvgWrongProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 19H3.9a1.4 1.4 0 0 1-1.4-1.4v-10a1.4 1.4 0 0 1 1.4-1.4h14a1.4 1.4 0 0 1 1.4 1.4V8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m18.848 6.57-2.633-3.947A1.4 1.4 0 0 0 15.053 2H6.746a1.4 1.4 0 0 0-1.165.623l-2.63 3.948M10.9 2v4.2M22.805 20.43a1.78 1.78 0 0 1-.06 1.73 1.8 1.8 0 0 1-1.507.84h-8.471a1.8 1.8 0 0 1-1.507-.84 1.78 1.78 0 0 1-.07-1.73l4.211-8.45a1.78 1.78 0 0 1 1.587-.98 1.77 1.77 0 0 1 1.586.98zM17 20h.01M17 15v2"
  })));
};
export default SvgWrongProducts;